import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ABTestValue, ABTestValueLabelMap } from '@app/org-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend';
import { _values } from '@nu-art/ts-common';
const adapter = SimpleListAdapter(_values(ABTestValue), value => _jsx(_Fragment, { children: ABTestValueLabelMap[value.item] }));
const mandatoryProps_Dropdown = {
    adapter: adapter,
    caret: DropDown_DefaultCaret,
    placeholder: 'Choose AB test value'
};
export const Dropdown_ABTestValue = TS_DropDown.prepareEditable(mandatoryProps_Dropdown);
//# sourceMappingURL=ui-components.js.map